"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUniqueNuclei = void 0;
function getUniqueNuclei(nuclei) {
    const uniqueNuclei = {};
    for (const nucleus of nuclei) {
        const _nuclei = nucleus.split(',');
        for (const _nucleus of _nuclei) {
            uniqueNuclei[_nucleus.toUpperCase()] = true;
        }
    }
    return Object.keys(uniqueNuclei);
}
exports.getUniqueNuclei = getUniqueNuclei;
